export const SharedConstants = {
  smallRowHeight: 25,
  defaultTableBodyHeight: 600,
  defaultModalHeight: 400,
  defaultPageHeight: 800,

  // FB
  defaultOtherLabelLength: 35,
  defaultHeader: 50,
  debugQuestionLibraryLoadDelay: 500,
};
